<template>

  <section class="tes-comments__wrapper">

    <EllipsisLoader :loading="loading"/>

    <slot name="header"
          :count="pagination?.count() ?? 0">
      <header class="tes-comments__header">
        <h2 id="comments" class="tes-comments__head">
          {{ initialCount }}  {{commentsCountTitle}}
        </h2>
      </header>
    </slot>

    <CommentView :level="0"
                 :ownerType="ownerType" :ownerId="ownerId"
                 :item="item"
                 :items="items"
                 v-for="item in top" @answer="openCommentForm"/>

    <PostsPagination
      :pagination="pagination" urlPattern="#comments/page/:page/" :startFromZero="false"
      @changePage="changePage"/>

    <button type="button" class="tes-comments__create-button" @click="openCommentForm(0)">Оставить комментарий</button>
    <div :id="`tt_${ownerType}_${ownerId}_0`" class="tes-comment__reply-teleport"></div>

    <teleport :to="`#tt_${ownerType}_${ownerId}_${commentId}`" :disabled="!commentId">
      <div :class="[
        'tes-comments__form',
        commentId ? 'tes-comments__form_reply' : '',
        loadingForm ? 'tes-comments__form_loading' : ''
        ]" v-if="form || loadingForm">
        <span class="tes-comments__form-close" @click="closeCommentForm" v-if="form">
          <span class="tes-comments__form-close-icon"><CloseIcon class="tes-comments__form-close-icon"/></span>
          <span class="tes-comments__form-close-title"> закрыть</span>
        </span>
        <component :is="form" :ownerType="ownerType" :ownerId="ownerId" :commentId="commentId"/>
        <EllipsisLoader :loading="loadingForm"/>
      </div>
    </teleport>

  </section>

</template>

<script lang="ts">
import Comment, {CommentData, CommentInterface} from '../../objects/comment/Comment'
import {computed, onMounted, onServerPrefetch, ref, shallowRef, watch} from 'vue'
import Pagination, {PaginationData} from '../../objects/Paginator'
//import {useRouter} from 'vue-router'

import {useStore} from 'vuex'
import CommentView from './CommentView.vue'
import PostsPagination from '../../components/post/PostsPagination.vue'


import CloseIcon from '~/assets/icons/close-v2.svg'


export default {
  name: 'CommentListView',
  components: {
    CommentView,
    PostsPagination,
    CloseIcon
  },
  props: {
    initialCount: {
      type: Number,
      require: true,
    },
    ownerType: {
      type: String,
      require: true
    },
    ownerId: {
      type: Number,
      require: true
    },
    itemsOnPage: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: [Number, String],
      required: false,
      default: 1
    },
  },
  beforeRouteLeave() {
    console.log('route leave')
  },
  async setup(props) {
    const store = useStore()
    const loading = ref(false)
    const top = ref([] as Array<CommentInterface>)
    const items = ref({} as { [key: number]: Array<CommentInterface> })

    let page = parseInt(props.pageNum)
    const pagination = ref(
      new Pagination({per_page: props.itemsOnPage, current_page: isNaN(page) ? 1 : page} as PaginationData)
    )

    const load = () => {
      if (!props.ownerId) {
        return;
      }

      top.value = [] as Array<CommentInterface>
      items.value = [] as { [p: number]: Array<CommentInterface> }
      loading.value = true

      return store.dispatch(
        'comments/loadDataForGroupedComments',
        {
          type: {owner_type: props.ownerType, owner_id: props.ownerId},
          paginator: pagination.value.paginator(),
          sort: null,
          filter: null
        },
        {root: true}
      ).then(data => {

        pagination.value = new Pagination(JSON.parse(JSON.stringify(data.meta)) as PaginationData)
        data.data.forEach((item) => {
          let comment = new Comment(item as CommentData);
          if (item.comment_id) {
            if (typeof items.value[item.comment_id as number] === 'undefined') {
              items.value[item.comment_id as number] = [] as Array<CommentInterface>
            }
            items.value[item.comment_id as number].push(comment)
          } else {
            top.value.push(comment)
          }
        })

      }).finally(() => loading.value = false)
    }

    const commentId = ref(0)
    const loadingForm = ref(false)
    const form = shallowRef()
    //const router = useRouter()
    const openCommentForm = async (id: number) => {
      form.value = null
      loadingForm.value = true
      commentId.value = id
      let f = await (() => import('../form/CommentBlogForm.vue'))()
      if (f.default) {
        form.value = f.default
        // await router.push({hash: `#created_${props.ownerType}_${props.ownerId}_${commentId.value}`})
      }
      loadingForm.value = false
    }
    const closeCommentForm = async () => {
      commentId.value = 0
      form.value = null
    }

    const changePage = (num: number) => {
      pagination.value.setCurrentPage(num)
      load()
    }

    const commentsCountTitle = computed(():string => {
      let bl = Math.floor((props.initialCount / 10) % 10);
      let l = props.initialCount % 10;
      let endings = 'й';
      if ((bl > 10 && bl < 20) || l === 0 || l > 4) {
        endings = 'ев';
      } else if (l > 1 && l < 5) {
        endings = 'я';
      }
      return `Комментари${endings}`;
    })

    onMounted(() => {
      load()
    })

    watch(() => props.ownerId, () => {
      load()
    })

    onServerPrefetch(() => {
      return load()
    })

    return {
      top, items, pagination, loading,
      commentId, closeCommentForm, openCommentForm, form, loadingForm,
      changePage, commentsCountTitle
    }
  }
}
</script>
